const order = [
    {
        path: '/system',
        name: 'system.menu',
        component: () => import('@/views/system/SystemMenu.vue'),
        meta: {
            env:['production'],
            pageTitle: 'Opções do Sistema',
            roles: [5,],
        },
    },
    {
        path: '/system/queues',
        name: 'system.queues.list',
        component: () => import('@/views/system/QueuesList.vue'),
        meta: {
            env:['production'],
            pageTitle: 'Status da Fila',
            roles: [5],
        },
    },
    {
        path: '/system/last-sync',
        name: 'system.last-sync.list',
        component: () => import('@/views/system/LastSynchronization.vue'),
        meta: {
            env:['production'],
            pageTitle: 'Dados de Sincronização',
            roles: [5],
        },
    },
    {
        path: '/system/queues/job',
        name: 'system.queue.job.detail',
        component: () => import('@/views/system/QueueJobDetail.vue'),
        meta: {
            env: ['production'],
            pageTitle: 'Detalhe da fila',
            roles: [5],
        },
    },
    {
        path: '/system/jobs',
        name: 'system.job.list',
        redirect: to => ({
            name: 'system.queue.job.detail',
            query: {
                job_name: to.query.job_name || to.query.job,
                queue: to.query.queue,
                tab: to.query.tab,
            },
        }),
    },
    {
        path: '/system/tutorials',
        name: 'system.tutorials',
        component: () => import('@/views/system/SystemTutorials.vue'),
        meta: {
            env: ['production'],
            pageTitle: 'Tutoriais',
            roles: [5],
        },
    },

]

export default order
